"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionInSlider = exports.maxItemWidth = exports.largeMinWidth = exports.largeMaxWidth = exports.largeGap = exports.baseNumberOfElements = exports.MEDIA_IS_VIDEO = exports.MEDIA_IMAGE = exports.MEDIA_DESCRIPTION = exports.MEDIA_BUTTON = exports.MEDIA = void 0;
// slider
const maxItemWidth = exports.maxItemWidth = 280;
const largeMinWidth = exports.largeMinWidth = 180;
const largeMaxWidth = exports.largeMaxWidth = 250;
const baseNumberOfElements = exports.baseNumberOfElements = 5;
const largeGap = exports.largeGap = 30;

// positions
const positionInSlider = exports.positionInSlider = {
  first: 1,
  second: 2,
  third: 3,
  forth: 4,
  fifth: 5
};
const MEDIA = exports.MEDIA = 'media';
const MEDIA_BUTTON = exports.MEDIA_BUTTON = 'media-button';
const MEDIA_IS_VIDEO = exports.MEDIA_IS_VIDEO = 'media-isVideo';
const MEDIA_IMAGE = exports.MEDIA_IMAGE = 'media-image';
const MEDIA_DESCRIPTION = exports.MEDIA_DESCRIPTION = 'media-description';
